import React, { useEffect, useState } from "react";
import "./RulesPage.css";

export default function RulesPage() {
  const [sections, setSections] = useState([]);
  const [openId, setOpenId] = useState(null);
  const [error, setError] = useState("");

  const API = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch(`${API}/api/rules`);
        if (!res.ok) {
          setError("Failed to load rules");
          return;
        }
        const data = await res.json();
        setSections(data);
        if (data.length > 0) setOpenId(data[0].id); // first section open by default
      } catch (err) {
        setError("Server error while loading rules");
      }
    };
    load();
  }, [API]);

  const toggle = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <div className="rules-page">
      <h2>Rules & SOP</h2>
      <p className="rules-intro">
        These guidelines help keep Crown Residences safe, well-maintained, and comfortable for
        every resident. Click a section to expand it.
      </p>

      {error && <p className="rules-error">{error}</p>}

      {sections.map((section) => (
        <div className="rules-section" key={section.id}>
          <button
            className="rules-section-header"
            onClick={() => toggle(section.id)}
            aria-expanded={openId === section.id}
          >
            <span>{section.title}</span>
            <span className={`rules-chevron ${openId === section.id ? "open" : ""}`}>▾</span>
          </button>

          {openId === section.id && (
            <ul className="rules-points">
              {section.points.map((point, i) => (
                <li key={i}>{point}</li>
              ))}
            </ul>
          )}
        </div>
      ))}

      {sections.length === 0 && !error && (
        <p className="rules-empty">No rules published yet.</p>
      )}
    </div>
  );
}